<template>
  <div class="go-v2">
    <!-- 顶部导航 -->
    <div class="go-v2__navbar">
      <!-- <img
        src="@/assets/svg/go.svg"
        alt="TVU Go"
        class="go-v2__logo" /> -->
      <span class="go-v2__logo">
        <svg
          class="logo-svg"
          width="96"
          height="48"
          viewBox="0 0 96 48"
          fill="#2FB23C"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M84.8804 43.7751C77.4772 48.5703 68.2936 48.8145 60.6607 44.5676C57.4822 42.7994 54.7072 40.6016 52.142 38.0125C51.6381 37.5041 51.6598 37.0085 52.036 36.423L56.5882 29.3385C56.7896 29.0249 57.051 28.8678 57.3219 28.8339C57.7165 28.7846 58.0045 28.9527 58.2853 29.2574C61.4799 32.72 65.8988 36.5185 70.7955 37.0247C75.4226 37.503 79.8649 35.4007 82.546 31.8853C85.4315 28.1019 86.0986 23.1602 84.3465 18.7868C81.3273 11.2505 72.3319 8.2612 65.3278 12.2833C61.2418 14.6298 57.7098 18.9372 54.9676 22.8089L48.9951 31.2415C45.6341 35.9867 41.3218 40.9252 36.3751 43.9982C27.2381 49.6737 15.4482 48.5059 7.62606 41.246C-0.16501 34.0148 -2.27792 22.4493 2.6438 12.9026C7.44568 3.58758 17.8547 -1.6139 28.3602 0.460158C32.2692 1.23212 35.7246 3.01593 38.9702 5.35968C41.4427 7.14513 42.1654 10.3746 40.3815 12.886C38.6533 15.3185 35.1823 15.7793 32.7631 13.8618C31.0454 12.5003 29.1917 11.468 27.0366 10.9102C22.7242 9.79464 18.2437 10.9113 14.9243 13.8734C11.7963 16.6645 10.0952 20.8608 10.5614 25.2342C10.9744 29.1065 12.9113 32.5552 16.1153 34.7547C20.7567 37.9409 26.707 37.8371 31.3756 34.7409C33.731 33.1785 35.6924 31.2909 37.5061 28.9965L29.2394 29.001C26.2213 29.0027 23.7516 26.918 23.6084 23.9855C23.4619 20.9968 25.8162 18.466 28.918 18.466H45.2417C48.9369 13.2895 52.4861 8.53037 57.636 4.71362C65.9365 -1.43794 77.3479 -1.59673 85.7567 4.40395C92.2252 9.0199 95.9706 16.4858 95.7764 24.3911C95.5842 32.1562 91.5537 39.4522 84.8814 43.7745L84.8804 43.7751Z"/>
        </svg>
      </span>
      <div
        class="go-v2__menu-icon"
        @click="menuVisible = true">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <!-- 侧边菜单 -->
    <transition name="menu-fade">
      <div
        v-if="menuVisible"
        class="go-v2__menu-overlay"
        @click="menuVisible = false">
        <transition name="menu-slide">
          <div
            v-if="menuVisible"
            class="go-v2__menu-drawer"
            @click.stop>
            <div
              class="go-v2__menu-close"
              @click="menuVisible = false">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18 6L6 18M6 6L18 18"
                  stroke="#2fb54e"
                  stroke-width="2"
                  stroke-linecap="round"/>
              </svg>
            </div>
            <nav class="go-v2__menu-nav">
              <p
                v-if="currentPlan"
                class="go-v2__menu-item"
                :class="{ 'disabled': portalLoading }"
                @click="!portalLoading && handlecustomerPortal()">
                {{ portalLoading ? 'Redirecting...' : 'Manage Subscription' }}
              </p>
              <p
                class="go-v2__menu-item"
                @click="logOut">Sign Out</p>
            </nav>
          </div>
        </transition>
      </div>
    </transition>

    <div
      class="go-v2__header"
      data-node-id="9601:8"
    >
      <div class="go-v2__title go-v2__title--desktop">Pricing</div>
      <div class="go-v2__title go-v2__title--mobile">Unlock TVU Go</div>
      <div class="go-v2__subtitle">Choose your plan.</div>
      <div class="go-v2__description">
        Pick the plan that matches your stream schedule. Cancel anytime.<br/>
        Start with a 3-day free trial.
      </div>
    </div>

    <div
      class="go-v2__plans-container"
      data-node-id="9601:9"
    >
      <!-- Payment frequency toggle -->
      <div class="go-v2__frequency">
        <div class="go-v2__frequency-label">Billing</div>
        <div class="go-v2__toggle">
          <button
            class="go-v2__toggle-btn"
            :class="{ active: billingFrequency === 'yearly' }"
            @click="billingFrequency = 'yearly'"
          >
            Yearly <span
              v-if="annualDiscountText"
              class="discount"
            >{{ annualDiscountText }}</span>
          </button>
          <button
            class="go-v2__toggle-btn"
            :class="{ active: billingFrequency === 'monthly' }"
            @click="billingFrequency = 'monthly'"
          >
            Monthly
          </button>
        </div>
      </div>

      <div class="go-v2__plans">
        <div
          v-for="(p, idx) in filteredPlans"
          :key="p.id"
          class="go-v2__card"
          :data-node-id="idx === 0 ? '9601:11' : '9601:43'"
        >
          <div
            v-if="p.display.mostPopular"
            class="go-v2__card-badge">Best for IRL</div>
          <div class="go-v2__card-name">{{ p.display.name }}</div>
          <div class="go-v2__card-price">
            {{ currencySymbol }}<span class="go-v2__price-int">{{ getPriceParts(p).integer }}</span><sup
              v-if="getPriceParts(p).decimal !== '00'"
              class="go-v2__price-dec">{{ getPriceParts(p).decimal }}</sup><span class="go-v2__price-unit"> / month</span>
          </div>
          <div
            v-if="billingFrequency === 'yearly'"
            class="go-v2__card-billing"
          >Billed Annually</div>

          <div
            v-if="getCardDescription(p)"
            class="go-v2__card-desc">
            {{ getCardDescription(p) }}
          </div>
          <ul class="go-v2__features">
            <li
              v-for="(line, i) in getCardFeatures(p)"
              :key="i"
              class="go-v2__feature"
            >
              <span class="check">✓</span>
              <span>{{ line }}</span>
            </li>
          </ul>

          <div class="go-v2__cta-area">
            <div
              class="go-v2__trial"
              :class="p.display.mostPopular ? 'go-v2__trial--popular' : 'go-v2__trial--secondary'"
              v-if="p.meta.trialDays"
            >
              Start {{ p.meta.trialDays }}-day free trial
            </div>
            <el-button
              class="go-v2__cta"
              :class="p.id === currentPlan?.planId
                ? (p.display.mostPopular ? '' : 'go-v2__cta--cancel')
                : (!p.display.mostPopular ? 'go-v2__cta--secondary' : '')"
              :loading="previewLoading && pendingPlan?.id === p.id"
              :disabled="previewLoading"
              @click="p.id === currentPlan?.planId ? handlecustomerPortal() : choosePlan(p)"
            >
              {{ getPlanBtnText(p) }}
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="go-v2__compare"
      data-node-id="9601:83"
      v-if="featureRows.length"
    >
      <div class="go-v2__compare-title">Compare plans</div>
      <div class="compare-row compare-row--header">
        <div class="compare-col label compare-col--plan-name">Plan</div>
        <div
          v-for="(p, i) in filteredPlans"
          :key="i"
          class="compare-col val compare-col--plan-name"
        >{{ p.display.name }}</div>
      </div>
      <div
        v-for="(row) in featureRows"
        :key="row.key"
        class="compare-row"
      >
        <!-- :style="{ color: rowIdx < 1 ? '#2fb54e' : row.color }" -->
        <div class="compare-col label">
          <div class="label-text">{{ row.label }}</div>
          <div
            class="label-desc"
            v-if="row.description">{{ row.description }}</div>
        </div>
        <div class="compare-col val">{{ formatCell(row.key, 0) }}</div>
        <div class="compare-col val">{{ formatCell(row.key, 1) }}</div>
      </div>
    </div>

    <!-- 底部信息 -->
    <div class="go-v2__footer">
      <svg
        class="logo-svg"
        width="96"
        height="48"
        viewBox="0 0 96 48"
        fill="#FFFFFF80"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M84.8804 43.7751C77.4772 48.5703 68.2936 48.8145 60.6607 44.5676C57.4822 42.7994 54.7072 40.6016 52.142 38.0125C51.6381 37.5041 51.6598 37.0085 52.036 36.423L56.5882 29.3385C56.7896 29.0249 57.051 28.8678 57.3219 28.8339C57.7165 28.7846 58.0045 28.9527 58.2853 29.2574C61.4799 32.72 65.8988 36.5185 70.7955 37.0247C75.4226 37.503 79.8649 35.4007 82.546 31.8853C85.4315 28.1019 86.0986 23.1602 84.3465 18.7868C81.3273 11.2505 72.3319 8.2612 65.3278 12.2833C61.2418 14.6298 57.7098 18.9372 54.9676 22.8089L48.9951 31.2415C45.6341 35.9867 41.3218 40.9252 36.3751 43.9982C27.2381 49.6737 15.4482 48.5059 7.62606 41.246C-0.16501 34.0148 -2.27792 22.4493 2.6438 12.9026C7.44568 3.58758 17.8547 -1.6139 28.3602 0.460158C32.2692 1.23212 35.7246 3.01593 38.9702 5.35968C41.4427 7.14513 42.1654 10.3746 40.3815 12.886C38.6533 15.3185 35.1823 15.7793 32.7631 13.8618C31.0454 12.5003 29.1917 11.468 27.0366 10.9102C22.7242 9.79464 18.2437 10.9113 14.9243 13.8734C11.7963 16.6645 10.0952 20.8608 10.5614 25.2342C10.9744 29.1065 12.9113 32.5552 16.1153 34.7547C20.7567 37.9409 26.707 37.8371 31.3756 34.7409C33.731 33.1785 35.6924 31.2909 37.5061 28.9965L29.2394 29.001C26.2213 29.0027 23.7516 26.918 23.6084 23.9855C23.4619 20.9968 25.8162 18.466 28.918 18.466H45.2417C48.9369 13.2895 52.4861 8.53037 57.636 4.71362C65.9365 -1.43794 77.3479 -1.59673 85.7567 4.40395C92.2252 9.0199 95.9706 16.4858 95.7764 24.3911C95.5842 32.1562 91.5537 39.4522 84.8814 43.7745L84.8804 43.7751Z"/>
      </svg>
      <div class="go-v2__footer-links">
        <a
          href="https://www.tvunetworks.com/company-privacy-notice/"
          class="go-v2__footer-link">Privacy Policy</a>
        <a
          href="https://www.tvunetworks.com/company-terms-and-conditions/"
          class="go-v2__footer-link">TVU Go Terms Of Use</a>
        <a
          href="https://www.tvunetworks.com/cookie-policy/"
          class="go-v2__footer-link">Cookies Policy</a>
        <!-- <a
          href="#"
          class="go-v2__footer-link">Subscriber Agreement</a>
        <a
          href="#"
          class="go-v2__footer-link">Help</a>
        <a
          href="#"
          class="go-v2__footer-link">Supported Devices</a> -->
        <a
          href="https://tvugo.app/about-us"
          class="go-v2__footer-link about-us">About Us</a>
      </div>
      <div class="go-v2__footer-copyright">
        TVU Go is a paid subscription service. Its content is subject to availability. The TVU Go service is marketed by TVU Networks. All Rights Reserved.
      </div>
    </div>

    <el-dialog
      :visible.sync="checkoutVisible"
      :before-close="handleCloseCheckOut"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      custom-class="checkout-dialog">
      <div
        id="checkout"
        ref="checkoutContainer"></div>
      <div
        v-if="paymentComplete"
        class="checkout-success">
        <div class="checkout-success__icon">✓</div>
        <div class="checkout-success__title">Payment successful!</div>
        <a
          v-if="isMobile"
          class="checkout-success__btn"
          @click="openInApp">Open in App</a>
        <button
          v-else
          class="checkout-success__btn"
          @click="handleCloseCheckOut">Close</button>
      </div>
    </el-dialog>

    <!-- IAP Subscription Dialog -->
    <el-dialog
      :visible.sync="iapVisible"
      :close-on-click-modal="true"
      custom-class="iap-dialog">
      <div class="iap-dialog__title">Manage Subscription</div>
      <div class="iap-dialog__body">
        Your subscription was purchased through Apple. To make changes, visit Apple Subscriptions.
      </div>
      <div class="iap-dialog__actions">
        <a
          href="https://apps.apple.com/account/subscriptions"
          target="_blank"
          class="iap-dialog__btn">Go to Apple</a>
      </div>
    </el-dialog>

    <!-- Plan Change Dialog -->
    <el-dialog
      :visible.sync="planChangeVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      custom-class="plan-change-dialog">
      <template v-if="previewData">
        <!-- UPGRADE -->
        <template v-if="previewData.changeType === 'UPGRADE'">
          <div class="pcd__title">Upgrade subscription</div>
          <div class="pcd__body">
            <p>You're upgrading to <span class="pcd__plan-name">{{ pendingPlanName }}</span>. The change will take effect immediately.</p>
            <p>You'll be charged today for the difference, prorated based on the time remaining in your current billing cycle.</p>
          </div>
          <div class="pcd__divider"></div>
          <ul class="pcd__items">
            <li><strong>Due today:</strong> {{ formatAmount(previewData.immediateChargeAmount) }}</li>
            <li><strong>Next billing:</strong> {{ formatAmount(previewData.nextBillingAmount) }} on {{ formatDate(previewData.nextBillingDate) }}</li>
          </ul>
          <div class="pcd__hint">Confirm to complete the upgrade.</div>
          <div class="pcd__actions">
            <button
              class="pcd__btn pcd__btn--cancel"
              @click="planChangeVisible = false">Cancel</button>
            <button
              class="pcd__btn pcd__btn--confirm"
              :disabled="planChangeLoading"
              @click="confirmPlanChange">
              {{ planChangeLoading ? 'Processing...' : 'Confirm upgrade' }}
            </button>
          </div>
        </template>
        <!-- DOWNGRADE -->
        <template v-if="previewData.changeType === 'DOWNGRADE'">
          <div class="pcd__title">Downgrade subscription</div>
          <div class="pcd__body">
            <p>You're changing your subscription from <span class="pcd__plan-name">{{ currentPlanName }}</span> to <span class="pcd__plan-name">{{ pendingPlanName }}</span>.</p>
            <p>Your new plan will take effect on your next billing date. You'll keep your current features until then.</p>
          </div>
          <div class="pcd__divider"></div>
          <ul class="pcd__items">
            <li><strong>Next billing:</strong> {{ formatAmount(previewData.nextBillingAmount) }} for <span class="pcd__plan-name">{{ pendingPlanName }}</span> on {{ formatDate(previewData.nextBillingDate) }}</li>
          </ul>
          <div class="pcd__hint">Confirm to complete the downgrade.</div>
          <div class="pcd__actions">
            <button
              class="pcd__btn pcd__btn--cancel"
              @click="planChangeVisible = false">Cancel</button>
            <button
              class="pcd__btn pcd__btn--confirm"
              :disabled="planChangeLoading"
              @click="confirmPlanChange">
              {{ planChangeLoading ? 'Processing...' : 'Confirm downgrade' }}
            </button>
          </div>
        </template>
        <!-- CHANGE -->
        <template v-if="previewData.changeType === 'SUBSCRIBE_AND_CANCEL'">
          <div class="pcd__title">Change subscription</div>
          <div class="pcd__body">
            <p>You're switching from <span class="pcd__plan-name">{{ currentPlanName }}</span> ({{ currentPlanCycle }}) to <span class="pcd__plan-name">{{ pendingPlanName }}</span> ({{ pendingPlanCycle }}).</p>
            <p>Choose when to apply this change:</p>
          </div>
          <div class="pcd__cards">
            <div class="pcd__card pcd__card--recommended">
              <div class="pcd__card-title">
                Start on next billing date
                <span class="pcd__card-tag">(Recommended)</span>
              </div>
              <div class="pcd__card-desc">Keep your current plan until the end of your billing cycle.</div>
              <ul class="pcd__card-items">
                <li>No changes today</li>
                <li>Your new plan will start on {{ formatDate(previewData.nextBillingDate) }}</li>
                <li>You'll be charged {{ formatAmount(previewData.nextBillingAmount) }} at that time</li>
              </ul>
              <button
                class="pcd__btn pcd__btn--schedule"
                disabled>Schedule Change</button>
            </div>
            <div class="pcd__card pcd__card--now">
              <div class="pcd__card-title">Start Now</div>
              <ul class="pcd__card-items">
                <li>Switch immediately and start using <span class="pcd__plan-name">{{ pendingPlanName }}</span> today</li>
                <li>Your current {{ currentPlanCycle }} plan will end immediately</li>
                <li>You'll be charged {{ formatAmount(previewData.immediateChargeAmount) }} today to start <span class="pcd__plan-name">{{ pendingPlanName }}</span></li>
              </ul>
              <button
                class="pcd__btn pcd__btn--start-now"
                :disabled="planChangeLoading"
                @click="confirmPlanChange">
                {{ planChangeLoading ? 'Processing...' : 'Start Now' }}
              </button>
            </div>
          </div>
          <div class="pcd__actions">
            <button
              class="pcd__btn pcd__btn--cancel"
              @click="planChangeVisible = false">Cancel</button>
          </div>
        </template>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getPlans, userHasSubscription } from '@/common/checkuser'
import { buildStripPaymentClientParams } from './webAppCheckout'
import {
  initWebAppTracking,
  trackPricingScreenViewed,
  trackPlanSelected,
  trackPaymentMethodConfirmed,
  trackTrialStarted
} from './webAppTracking'
export default {
  data () {
    return {
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone|Mobile|Tablet|Silk/i.test(navigator.userAgent) ||
                (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) ||
                (/Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1),
      isAndroid: /Android/i.test(navigator.userAgent),
      product: '',
      plans: [],
      allPlans: [], // 存储所有计划（monthly + yearly）
      billingFrequency: 'monthly', // 'monthly' 或 'yearly'
      currencySymbol: '$',
      featureRows: [],
      checkoutVisible: false,
      checkout: null,
      paymentComplete: false,
      currentPlan: null,
      menuVisible: false, // 控制侧边菜单显示
      portalLoading: false,
      planChangeVisible: false,
      previewData: null,
      pendingPlan: null,
      planChangeLoading: false,
      previewLoading: false,
      iapVisible: false
    }
  },
  mounted () {
    // const product = this.$route?.query?.product || 'TVUGO'
    this.product = 'TVUGO'
    initWebAppTracking(this.userId)
    trackPricingScreenViewed()
    this.getGoPlans(() => {
      this.checkSubscription('init')
    })
  },
  beforeDestroy () {
    // 清理滚动样式
    document.body.style.overflow = ''
  },
  computed: {
    ...mapState({
      emailId: state => state.userInfo.email,
      // GA4 user_id：用于把 Web 支付事件关联回 Android App 用户（SPAR-593）
      // /user/info 返回体的具体字段名待后端确认，缺失时不上报该参数
      userId: state => state.userInfo.userId || state.userInfo.id || '',
      logOutUrl: state => state.initMsg.logOutUrl
    }),
    // 根据选择的计费频率过滤计划
    annualDiscountText () {
      const yearlyPlan = this.allPlans.find(p => {
        const recurring = p.meta?.plans?.[0]?.recuring || p.meta?.plans?.[0]?.recurring
        return recurring === 'yearly'
      })
      const discount = yearlyPlan?.meta?.plans?.[0]?.annualDiscount
      if (!discount) return ''
      // 用字符串拆分 + 整数加法将小数转为百分比，避免浮点运算精度问题
      // 例如：0.1667 -> '16.67% OFF'，0.2 -> '20% OFF'
      const [intStr, decStr = ''] = String(discount).split('.')
      const dec = decStr.padEnd(2, '0') // 补齐至少2位小数，如 '2' -> '20'
      const whole = Number(intStr) * 100 + Number(dec.slice(0, 2)) // 取前两位作为整数部分
      const frac = dec.slice(2).replace(/0+$/, '') // 剩余位为小数部分，去除尾零
      return (frac ? `${whole}.${frac}` : `${whole}`) + '% OFF'
    },
    filteredPlans () {
      return this.allPlans.filter(p => {
        const recurring = p.meta?.plans?.[0]?.recuring || p.meta?.plans?.[0]?.recurring
        return recurring === this.billingFrequency
      })
    },
    currentPlanName () {
      if (!this.currentPlan) return ''
      const p = this.allPlans.find(pl => pl.id === this.currentPlan.planId)
      return p ? p.display.name : this.currentPlan.planId
    },
    pendingPlanName () {
      return this.pendingPlan ? this.pendingPlan.display.name : ''
    },
    currentPlanCycle () {
      const p = this.allPlans.find(pl => pl.id === this.currentPlan?.planId)
      return p?.display?.recurring || 'monthly'
    },
    pendingPlanCycle () {
      return this.pendingPlan?.display?.recurring || 'monthly'
    },
    isIapSubscription () {
      return this.currentPlan?.paymentMode === 2
    }
  },
  watch: {
    billingFrequency () {
      this.updateFeatureRows()
    },
    menuVisible (val) {
      // 菜单打开时禁用背景滚动
      if (val) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    }
  },
  methods: {
    handlecustomerPortal () {
      if (this.isIapSubscription) {
        this.iapVisible = true
        return
      }
      if (this.portalLoading) return
      this.portalLoading = true
      const newWindow = window.open('', '_blank')
      if (newWindow) {
        newWindow.document.write('<!DOCTYPE html><html><head><meta charset="utf-8"><title>Redirecting...</title><style>body{background-color:#000;color:#fff;display:flex;flex-direction:column;align-items:center;justify-content:center;height:100vh;margin:0;font-family:sans-serif}.loader{border:4px solid #333;border-top:4px solid #2fb54e;border-radius:50%;width:40px;height:40px;animation:spin 1s linear infinite;margin-bottom:20px}@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}</style></head><body><div class="loader"></div><p>Redirecting to Customer Portal...</p></body></html>')
        newWindow.document.close()
      }
      const url = '/route-billing/billing-service/user/stripPortalByUser?product=' + this.product
      this.$axios.get(url).then(res => {
        if (res.data.errorCode == '0x0') {
          const resultUrl = res.data.result
          if (newWindow) {
            newWindow.location.href = resultUrl
          }
        } else {
          if (newWindow) newWindow.close()
          if (res.data.errorCode === '80E00132') {
            this.$message && this.$message({ type: 'warning', message: 'Contact Owner/Finance member for your group to Purchase', duration: 3000, showClose: true })
          } else {
            this.$message && this.$message.error(res.data.result || 'Failed to get portal link.')
          }
        }
      }).catch(() => {
        if (newWindow) newWindow.close()
        this.$message && this.$message.error('Network error.')
      }).finally(() => {
        this.portalLoading = false
      })
    },
    logOut () {
      const url = '/route-billing/billing-service/user/logout?accessToken='
      this.$axios.get(url).then((res) => {
        if (res.data.errorCode == '0x0') {
          window.location.replace(this.logOutUrl)
        }
      })
    },
    // 查看用户的当前订阅
    checkSubscription (type) {
      const params = {
        product: this.product,
        classification: 3
      }
      userHasSubscription(params).then(({ data, errors }) => {
        if (data.subscription && data.subscription.subscriptions) {
          const list = data.subscription.subscriptions || []
          const statusList = [0, 3, 1]
          // 当前订阅的plan
          // 过滤掉 serviceType: "_Global" 的
          // 过滤为 status 0 3的
          const currentPlan = list.filter(i => (i.serviceType !== '_Global' && statusList.includes(i.status)))
          this.currentPlan = currentPlan[0] || null
          if (type === 'init') {
            this.billingFrequency = this.currentPlan ? this.currentPlan.chargeCycle === 3 ? 'yearly' : 'monthly' : 'monthly'
            if (this.isIapSubscription) {
              this.iapVisible = true
            }
          }
          // this.subscriptionList = list
        } else if (errors && errors.length) {
          const { errorCode } = errors[0].extensions || {}
          if (errorCode == '80E00129') {
            MessageBox.alert("You don't belong to any Token User Group.Please contact your company's administrator.", { confirmButtonText: 'OK' })
          }
        }
      })
    },
    // 解析并填充 UI 所需的数据
    getGoPlans (callback) {
      const params = {
        customerId: this.emailId,
        product: this.product,
        classification: 3,
        excludeGlobal: true
      }
      getPlans(params).then((res) => {
        // handle response if needed
        const data = res.data
        if (data.plan && data.plan.plans) {
          const plans = data.plan.plans
          console.log(plans)

          // 解析 metadata
          const uiPlans = []
          plans.forEach(item => {
            try {
              const meta = JSON.parse(item.metadata || '{}')

              const p0 = (meta.plans && meta.plans[0]) || {}
              const featuresArr = p0.features || []
              const fMap = {}
              featuresArr.forEach(f => { fMap[f.key] = f })
              const descRaw = (p0 && p0.description) || ''

              const descLines = descRaw
                ? descRaw.split(/<br\s*\/?>(?:\s*)?/i).map(s => s.trim()).filter(Boolean)
                : []

              // 获取价格和计费周期
              const recurring = p0.recuring || p0.recurring || 'monthly'
              const price = p0.price || p0.pricePerMonth || 0

              uiPlans.push({
                id: item.id,
                meta,
                display: {
                  name: p0.name,
                  price,
                  recurring,
                  ctaText: p0.ctaText,
                  descLines,
                  mostPopular: p0.mostPopular || false
                },
                fMap
              })

              if (meta.currency === 'USD') this.currencySymbol = '$'
            } catch (e) {
              // 忽略解析错误
            }
          })
          this.allPlans = uiPlans

          // 基于 meta.features 动态生成对比表行
          this.updateFeatureRows()
        }
        typeof callback === 'function' && callback()
      })
    },

    // 更新对比表行
    updateFeatureRows () {
      this.featureRows = this.buildFeatureRows(this.filteredPlans)
    },

    async previewPlanChange (plan) {
      if (this.previewLoading) return
      this.previewLoading = true
      this.pendingPlan = plan
      this.previewData = null
      try {
        const res = await this.$axios.get('/route-billing/billing-service/user/previewPlanChange', {
          params: {
            currentPlanId: this.currentPlan.planId,
            newPlanId: plan.id
          }
        })
        if (res.data.errorCode !== '0x0') {
          this.$message && this.$message.error(res.data.errorInfo || 'Failed to preview plan change.')
          return
        }
        const result = res.data.result
        this.previewData = result
        this.planChangeVisible = true
      } catch (e) {
        this.pendingPlan = null
        this.$message && this.$message.error('Network error.')
      } finally {
        this.previewLoading = false
      }
    },

    async confirmPlanChange () {
      this.planChangeLoading = true
      if (!this.currentPlan?.planId || !this.pendingPlan?.id) {
        this.$message && this.$message.error('Invalid plan selection.')
        this.planChangeLoading = false
        return
      }
      try {
        const res = await this.$axios.post('/route-billing/billing-service/user/changePlan', null, {
          params: {
            currentPlanId: this.currentPlan.planId,
            newPlanId: this.pendingPlan.id
          }
        })
        if (res.data.errorCode !== '0x0') {
          this.$message && this.$message.error(res.data.errorInfo || 'Failed to change plan.')
          return
        }
        this.planChangeVisible = false
        this.$message && this.$message.success('Plan changed successfully.')
        setTimeout(() => {
          this.checkSubscription()
        }, 1500)
      } catch (e) {
        this.$message && this.$message.error('Network error.')
      } finally {
        this.planChangeLoading = false
      }
    },

    async choosePlan (plan) {
      trackPlanSelected(plan.id)
      if (this.isIapSubscription) {
        this.iapVisible = true
        return
      }
      // Check if user has an existing subscription
      if (this.currentPlan && this.currentPlan.planId !== plan.id) {
        this.previewPlanChange(plan)
        return
      }

      const res = await this.$axios.get('/route-billing/billing-service/user/stripPaymentClient', {
        params: buildStripPaymentClientParams(plan.id)
      })
      if (res.data.errorCode !== '0x0') {
        if (res.data.errorCode === '80E00132') {
          this.$message && this.$message({ type: 'warning', message: 'Contact Owner/Finance member for your group to Purchase', duration: 3000, showClose: true })
        } else {
          this.$message && this.$message.error(res.data.result || 'Failed to initialize checkout.')
        }
        return
      }
      const clientSecret = res.data.result

      this.checkoutVisible = true
      await this.$nextTick()
      if (this.$refs.checkoutContainer) {
        this.$refs.checkoutContainer.innerHTML = ''
      }

      const stripe = window.Stripe(window.CONFIG.stripePublishKey)
      const checkout = await stripe.initEmbeddedCheckout({
        fetchClientSecret: () => Promise.resolve(clientSecret),
        onComplete: () => {
          // 必须在跳回 App 之前上报，事件走 beacon 传输以免页面卸载时丢失
          trackTrialStarted({ planId: plan.id, userId: this.userId })
          if (this.isMobile) {
            setTimeout(() => {
              const isAndroid = /Android/i.test(navigator.userAgent)
              if (isAndroid) {
                window.location.href = 'tvugo://www.tvunetworks.com/tvugo'
              } else {
                window.location.href = 'https://www.tvunetworks.com/tvugo'
              }
            }, 2000)
          }
          this.paymentComplete = true
        }
      })
      this.checkout = checkout
      checkout.mount('#checkout')
      trackPaymentMethodConfirmed(plan.id)
    },
    async handleCancelSubscription () {
      try {
        await this.$confirm(
          'Are you sure you want to cancel your subscription?',
          'Cancel Subscription',
          {
            confirmButtonText: 'Yes, Cancel',
            cancelButtonText: 'No',
            type: 'warning'
          }
        )
      } catch {
        return
      }
      try {
        const res = await this.$axios.post('/route-billing/billing-service/user/cancelCommitment', {
          product: this.product,
          planId: this.currentPlan.planId
        })
        if (res.data?.errorCode !== '0x0') {
          this.$message.error(res.data?.errorInfo || 'Failed to cancel subscription')
          return
        }
        this.$message.success('Subscription cancelled')
        this.currentPlan = null
      } catch (error) {
        console.error('Cancel subscription error:', error)
        this.$message.error('Failed to cancel subscription')
      }
    },
    openInApp () {
      const isAndroid = /Android/i.test(navigator.userAgent)
      window.location.href = isAndroid
        ? 'tvugo://www.tvunetworks.com/tvugo'
        : 'https://www.tvunetworks.com/tvugo'
    },
    handleCloseCheckOut () {
      this.checkSubscription()
      if (this.checkout) {
        this.checkout.unmount()
        this.checkout.destroy()
        this.checkout = null
      }
      this.checkoutVisible = false
      this.paymentComplete = false
    },

    // 从各 plan 的 meta.features 生成行，并按设计优先级排序
    buildFeatureRows (plans) {
      const map = new Map() // key -> { key, label }
      plans.forEach(p => {
        const meta = p?.meta || {}
        const p0 = (meta.plans && meta.plans[0]) || {}
        const features = Array.isArray(p0.features) ? p0.features : []
        features.forEach(f => {
          if (!map.has(f.key)) {
            map.set(f.key, {
              key: f.key,
              label: f.label,
              description: f.description,
              color: f.color
            })
          }
        })
      })

      // 保持首次出现顺序（Map 插入顺序）
      return Array.from(map.values())
    },

    // 卡片三行摘要优先使用 meta.description 的 <br> 拆分
    getCardLines (plan) {
      const lines = plan?.display?.descLines
      if (Array.isArray(lines) && lines.length) return lines
      // 兜底：按旧逻辑从 features 生成
      const arr = []
      const d = this.getFeatureValue(plan, 'destinations')
      if (d) arr.push(d)
      const p = this.getFeatureValue(plan, 'protocols')
      if (p) arr.push(p)
      const c = this.combinedFeatureText(plan)
      if (c) arr.push(c)
      return arr
    },

    // 组合第三条展示文案
    combinedFeatureText (plan) {
      const labels = []
      if (this.boolValue(plan, 'htmlGraphicOverlays')) labels.push('Overlay graphics')
      if (this.boolValue(plan, 'chatIntegration')) labels.push('chat integration')
      if (this.boolValue(plan, 'dualCamera')) labels.push('dual camera')
      return labels.join(', ')
    },

    // 获取某个特性的文本值
    getFeatureValue (plan, key) {
      const f = plan.fMap[key]
      if (!f) return ''
      if (typeof f.value === 'boolean') return f.value ? '✓' : '-'
      return f.value
    },

    boolValue (plan, key) {
      const f = plan.fMap[key]
      return !!(f && f.value === true)
    },

    // 对比表单元格格式化
    formatCell (key, planIndex) {
      const p = this.filteredPlans[planIndex]
      if (!p) return ''

      if (key === 'prioritySupport') {
        return this.boolValue(p, 'prioritySupport') ? 'Priority' : 'Standard'
      }
      const f = p.fMap[key]
      if (!f) return ''
      if (typeof f.value === 'boolean') return f.value ? '✓' : '-'
      return f.value
    },
    getDisplayPrice (p) {
      let price = p.display.price
      if (p.display.recurring === 'yearly') {
        price = price / 12
      }
      return Number(parseFloat(price).toFixed(2))
    },
    getPriceParts (p) {
      const price = this.getDisplayPrice(p).toFixed(2)
      const [integer, decimal] = price.split('.')
      return { integer, decimal: decimal || '00' }
    },
    getCardDescription (plan) {
      const lines = plan?.display?.descLines
      if (Array.isArray(lines) && lines.length > 0) return lines[0]
      return ''
    },
    getPlanBtnText (plan) {
      if (!this.currentPlan) return plan.display.ctaText || 'Choose Plan'
      if (plan.id === this.currentPlan.planId) return this.isMobile ? 'Manage' : 'Manage Subscription'
      return plan.display.ctaText || 'Choose Plan'
    },
    getCardFeatures (plan) {
      const lines = plan?.display?.descLines
      if (Array.isArray(lines) && lines.length > 1) return lines.slice(1)
      return []
    },
    formatAmount (cents) {
      return '$' + (cents / 100).toFixed(2)
    },
    formatDate (ms) {
      return new Date(ms).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
    }
  }
}
</script>

<style scoped lang="less">
.go-v2 {
  background: #000;
  color: #fff;
  min-height: 100%;
  padding: 0;
}

/* 顶部导航 */
.go-v2__navbar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 20px;
  background: #000;
  box-shadow: 0px 4px 20px 0px rgba(51, 225, 52, 0.17);
  position: relative;
  z-index: 10;
}
.go-v2__logo {
  height: 42px;
  width: auto;
  color: #2FB23C;
  display: flex;
  align-items: center;
  .logo-svg {
    cursor: pointer;
    height: 100%;
    width: auto;
  }
}
.go-v2__open-app {
  float: right;
  color: #2fb54e;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  border: 1px solid #2fb54e;
  border-radius: 20px;
  padding: 6px 16px;
  margin-right: 16px;
  transition: background 0.2s, color 0.2s;
  &:hover {
    background: #2fb54e;
    color: #000;
  }
}
.go-v2__menu-icon {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  gap: 6px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  span {
    display: block;
    width: 28px;
    height: 2px;
    background: #2fb54e;
    border-radius: 2px;
  }
}

/* 侧边菜单 */
.go-v2__menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
}

.go-v2__menu-drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 300px;
  max-width: 80vw;
  background: #0d0d0d;
  padding: 32px 24px;
  z-index: 1001;
}

.go-v2__menu-close {
  position: absolute;
  top: 24px;
  right: 24px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;
  &:hover {
    opacity: 0.8;
  }
}

.go-v2__menu-nav {
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-top: 80px;
  align-items: center;
}

.go-v2__menu-item {
  color: #fff;
  font-size: 18px;
  font-weight: 400;
  text-decoration: none;
  transition: color 0.2s;
  cursor: pointer;
  &:hover {
    color: #2fb54e;
  }
  &.disabled {
    opacity: 0.6;
    cursor: not-allowed;
    color: #888;
  }
}

/* 菜单动画 */
.menu-fade-enter-active,
.menu-fade-leave-active {
  transition: opacity 0.3s;
}
.menu-fade-enter,
.menu-fade-leave-to {
  opacity: 0;
}

.menu-slide-enter-active,
.menu-slide-leave-active {
  transition: transform 0.3s ease-out;
}
.menu-slide-enter,
.menu-slide-leave-to {
  transform: translateX(100%);
}

.go-v2__header {
  text-align: center;
  margin: 60px 0 40px;
  padding: 0 20px;
}
.go-v2__title {
  font-size: 32px;
  font-weight: 700;
  line-height: 1.2;
}
.go-v2__title--mobile {
  display: none;
}
.go-v2__subtitle {
  margin-top: 8px;
  color: #777;
  font-size: 24px;
  font-weight: 600;
}
.go-v2__description {
  margin-top: 16px;
  color: #888;
  font-size: 14px;
  line-height: 1.6;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.go-v2__plans-container {
  width: 960px;
  margin: 0 auto 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

/* Payment frequency toggle */
.go-v2__frequency {
  flex-shrink: 0;
  padding-top: 0;
}
.go-v2__frequency-label {
  color: #fff;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 24px;
  text-align: center;
}
.go-v2__toggle {
  position: relative;
  width: 259px;
  height: 24px;
  display: flex;
}
.go-v2__toggle-btn {
  position: absolute;
  top: 0;
  height: 24px;
  border-radius: 3.963px;
  font-size: 11px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s;
  border: 0.793px solid rgba(255, 255, 255, 0.5);
  background: transparent;
  color: #fff;
  text-align: center;
  padding: 2px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.6;
}
.go-v2__toggle-btn:first-child {
  left: 7.09%;
  right: 43.31%;
  box-shadow: 3.96px 0 3.17px 0 rgba(106, 255, 105, 0.3);
}
.go-v2__toggle-btn:last-child {
  left: 48.31%;
  right: 9.17%;
}

.go-v2__toggle-btn.active {
  background: #2fb54e;
  color: #fff;
  border-color: transparent;
  box-shadow: 3.96px 0 3.17px 0 rgba(106, 255, 105, 0.15);
  opacity: 1;
  z-index: 1;
}
.go-v2__toggle-btn .discount {
  color: #2fb54e;
  margin-left: 2px;
}
.go-v2__toggle-btn.active .discount {
  color: #fff;
}

.go-v2__plans {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(2, 300px);
  column-gap: 15px;
  position: relative;
}

.go-v2__card {
  background: #0d0d0d;
  border-radius: 24px;
  /* 允许内容增长，避免 trial 覆盖描述 */
  min-height: 340px;
  height: auto;
  padding: 30px 20px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  box-shadow: inset 0px -1px 2px 1px rgba(119, 119, 119, 1);
}
.go-v2__card-badge {
  position: absolute;
  top: 46px;
  right: 16px;
  color: #2fb54e;
  font-size: 12px;
  font-weight: 700;
  text-transform: capitalize;
  text-align: right;
  line-height: normal;
  white-space: nowrap;
}
.go-v2__card-name {
  color: #777;
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 4px;
  padding-right: 120px; /* 为徽章留出空间 */
  line-height: 1.6;
  text-align: left;
}
.go-v2__card-price {
  font-size: 32px;
  font-weight: 700;
  text-align: left;
  line-height: 1;
  margin-bottom: 4px;
}
.go-v2__price-int {
  font-size: 32px;
  font-weight: 700;
  vertical-align: baseline;
}
.go-v2__price-dec {
  font-size: 20px;
  font-weight: 700;
  vertical-align: super;
  line-height: 1;
}
.go-v2__price-unit {
  font-size: 16px;
  font-weight: 400;
  vertical-align: baseline;
}
.go-v2__card-billing {
  font-size: 15px;
  color: #777;
  font-weight: 600;
  text-align: left;
  margin-top: 2px;
}
.go-v2__card-desc {
  color: #777;
  font-size: 13px;
  font-weight: 500;
  // line-height: 20px;
  margin-top: 16px;
  text-align: left;
}
.go-v2__features {
  list-style: none;
  padding: 0;
  margin: 8px 0 0;
  flex: 1;
  min-height: 120px;
  text-align: left;
}
.go-v2__cta-area {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 8px;
}
.go-v2__feature {
  display: flex;
  align-items: flex-start;
  color: #bbb;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 10px;
}
.go-v2__feature .check {
  display: inline-block;
  width: 16px;
  color: #2fb54e;
  margin-right: 10px;
}
.go-v2__feature.multi span:last-child {
  color: #bbb;
}
.go-v2__trial {
  text-align: center;
  font-weight: 400;
  font-size: 12px;
  &.go-v2__trial--secondary {
    color: #fff;
  }
  &.go-v2__trial--popular {
    color: #2fb54e;
  }
}
.go-v2__cta {
  margin-top: 12px;
  height: 40px;
  border-radius: 10px;
  background: #2fb54e !important;
  color: #fff !important;
  font-weight: 600;
  border: none !important;
  cursor: pointer;
  &.go-v2__cta--secondary {
    background: transparent !important;
    color: #fff !important;
    border: 1px solid #fff !important;
  }
  &.go-v2__cta--cancel {
    background: transparent !important;
    color: #fff !important;
    border: 1px solid #fff !important;
  }
  &.is-disabled {
    background: #333 !important;
    color: #666 !important;
    border: none !important;
  }
}
.go-v2__cta:hover {
  filter: brightness(1.1);
}

.go-v2__compare {
  width: 866px;
  margin: 0 auto;
  padding-bottom: 40px;
}
.go-v2__compare-title {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  margin-bottom: 8px;
}
.compare-row--header {
  border-bottom: 2px solid #696969;
  .compare-col.label {
    font-size: 14px;
    font-weight: 500;
    color: #888;
  }
}
.compare-col--plan-name {
  color: #2fb54e !important;
  font-size: 14px;
  font-weight: 600;
}
.compare-row {
  display: grid;
  grid-template-columns: 340px 263px 263px;
  min-height: 70px;
  height: auto;
  align-items: center;
  border-bottom: 1px solid #696969;
}
.compare-col.label {
  padding-left: 20px;
  text-align: left;
  .label-text {
    color: #fff;
    font-size: 15px;
    font-weight: 600;
  }
  .label-desc {
    font-size: 13px;
    font-weight: 400;
    color: #fff;
  }
}
.compare-col.val {
  text-align: center;
  padding: 8px 16px;
}
/* 底部信息 */
.go-v2__footer {
  text-align: center;
  padding: 60px 40px 40px;
  margin-top: 80px;
  border-top: 1px solid #1a1a1a;
}
.go-v2__footer-logo {
  height: 40px;
  width: auto;
  margin-bottom: 32px;
}
.go-v2__footer-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px 24px;
  margin: 24px 0;
}
.go-v2__footer-link {
  color: #888;
  font-size: 16px;
  text-decoration: none;
  transition: color 0.2s;
  &:hover {
    color: #fff;
  }
  &.about-us {
    text-decoration: none;
  }
}
.go-v2__footer-copyright {
  color: #666;
  font-size: 16px;
  line-height: 1.6;
  max-width: 700px;
  margin: 0 auto;
}

.el-dialog__wrapper {
  color: #fff;
  ::v-deep .el-dialog.checkout-dialog {
    background: #fff;
    width: 400px;
    border-radius: 12px !important;
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.15), 0 8px 40px rgba(0, 0, 0, 0.8) !important;
    overflow: hidden;
    .el-dialog__header,
    .el-dialog__body {
      padding: 0;
    }
  }
}
.checkout-success {
  position: absolute;
  inset: 0;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  border-radius: inherit;
}
.checkout-success__icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #2fb54e;
  color: #fff;
  font-size: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.checkout-success__title {
  font-size: 20px;
  font-weight: 600;
  color: #000;
}
.checkout-success__btn {
  display: inline-block;
  padding: 12px 32px;
  background: #2fb54e;
  color: #000;
  font-size: 16px;
  font-weight: 700;
  border-radius: 24px;
  text-decoration: none;
  transition: filter 0.2s;
  &:hover {
    filter: brightness(0.9);
  }
}

// IAP Dialog styles (global override, outside scoped)
</style>
<style lang="less">
.iap-dialog.el-dialog {
  background: #1a1a1a;
  border-radius: 12px;
  text-align: left;
  width: 600px;
  .el-dialog__header { display: none; }
  .el-dialog__body { padding: 32px 28px 28px; }
  .iap-dialog__title {
    font-size: 18px;
    font-weight: 600;
    color: #fff;
    margin-bottom: 16px;
  }
  .iap-dialog__body {
    font-size: 14px;
    color: #aaa;
    line-height: 1.6;
    margin-bottom: 24px;
    word-break: break-word;
  }
  .iap-dialog__actions {
    display: flex;
    justify-content: flex-end;
  }
  .iap-dialog__btn {
    display: inline-block;
    padding: 10px 28px;
    background: #2fb54e;
    color: #fff;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    &:hover { background: #27a044; }
  }
}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
  .go-v2__navbar {
    padding: 8px 20px;
  }
  .go-v2__header {
    margin: 40px 0 30px;
  }
  .go-v2__plans-container {
    width: auto;
    padding: 0 16px;
    flex-direction: column;
    align-items: center;
  }
  .go-v2__frequency {
    margin-bottom: 20px;
  }
  .go-v2__plans {
    grid-template-columns: repeat(2, minmax(0, 300px));
    column-gap: 15px;
    justify-items: stretch;
  }
  .go-v2__compare {
    width: auto;
    padding: 0 16px;
  }
  .compare-row { grid-template-columns: 2fr 1.5fr 1.5fr; min-height: 60px; }
  /* 移除桌面占位元素，避免小屏错位 */
  .go-v2__plans::before {
    display: none;
  }
  .go-v2__footer {
    padding: 40px 20px 30px;
    margin-top: 60px;
  }
  .go-v2__footer-links {
    gap: 6px 16px;
  }
  ::v-deep .el-dialog.checkout-dialog {
    width: 400px;
  }
}

/* 移动端（按 Figma 390 宽稿） */
@media (max-width: 480px) {
  .go-v2 { padding: 0; }
  .go-v2__navbar {
    padding: 6px 16px;
  }
  // .go-v2__logo {
  //   height: 24px;
  // }
  .go-v2__menu-icon span {
    width: 24px;
  }
  .go-v2__header {
    margin: 30px 0 24px;
  }
  .go-v2__title { font-size: 26px; }
  .go-v2__title--desktop { display: none; }
  .go-v2__title--mobile { display: block; }
  .go-v2__description { display: none; }
  .go-v2__description {
    font-size: 13px;
    margin-top: 12px;
  }

  .go-v2__plans-container {
    width: auto;
    padding: 0 16px;
  }
  .go-v2__frequency {
    width: 100%;
    margin-bottom: 16px;
  }
  .go-v2__frequency-label {
    margin-bottom: 10px;
  }
  .go-v2__toggle {
    width: 100%;
    max-width: 300px;
    margin: 0 auto;
  }

  /* 两张卡片并排，充分利用屏幕宽度 */
  .go-v2__plans { width: 100%; padding: 0; grid-template-columns: repeat(2, 1fr); column-gap: 8px; row-gap: 0; justify-items: stretch; }
  .go-v2__card { width: auto; min-height: 320px; height: auto; padding: 14px 10px; }
  .go-v2__card-badge {
    top: 12px;
    right: 8px;
    font-size: 9px;
    white-space: nowrap;
  }
  .go-v2__card-name {
    font-size: 13px;
    padding-right: 0;
  }
  .go-v2__card-price { font-size: 22px; }
  .go-v2__price-int { font-size: 22px; }
  .go-v2__price-unit { font-size: 12px; }
  .go-v2__card-desc { font-size: 11px; margin-top: 8px; }
  .go-v2__features { margin-top: 8px; min-height: unset; }
  .go-v2__feature { font-size: 11px; margin-bottom: 6px; line-height: 1.4; }
  .go-v2__feature .check { width: 12px; margin-right: 5px; }
  .go-v2__trial { font-size: 12px; }
  .go-v2__cta { width: 100%; margin-top: 8px; height: 34px; font-size: 13px; }

  /* 338 宽对比表，标题占一行，两个值并排 */
  .go-v2__compare { width: 338px; padding: 0; }
  .compare-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
    row-gap: 6px;
    height: auto;
    padding: 8px 0;
  }
  .compare-col.label { grid-column: 1 / span 2; text-align: center; padding-left: 0; }
  .compare-row--header .compare-col.label { grid-column: 1 / span 2; font-size: 13px; }
  .compare-row--header .compare-col.val { grid-column: auto; }
  .compare-col.val { text-align: center; }
  /* 移除桌面占位元素 */
  .go-v2__plans::before { display: none; }

  /* 底部移动端样式 */
  .go-v2__footer {
    padding: 30px 16px 24px;
    margin-top: 40px;
  }
  .go-v2__footer-logo {
    height: 32px;
    margin-bottom: 24px;
  }
  .go-v2__footer-links {
    flex-direction: column;
    gap: 12px;
  }
  .go-v2__footer-link {
    font-size: 12px;
  }
  .go-v2__footer-copyright {
    font-size: 10px;
    padding: 0 8px;
  }

  ::v-deep .el-dialog.checkout-dialog {
    width: 90%;
    max-width: 400px;
  }
  ::v-deep .el-dialog.plan-change-dialog {
    width: 90%;
    max-width: 400px;
  }
  ::v-deep .el-dialog.iap-dialog {
    width: 90%;
    max-width: 400px;
  }
}

// Plan Change Dialog
/deep/ .plan-change-dialog {
  background: #1f1f1f;
  border-radius: 12px;
  width: 640px !important;
  text-align: left;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 40px;
  }
  @media (max-width: 680px) {
    width: calc(100vw - 24px) !important;
    margin-left: 12px;
    .el-dialog__body {
      padding: 24px 16px;
    }
  }
}
.pcd__body p,
.pcd__items li,
.pcd__card-desc,
.pcd__card-items li {
  word-break: normal;
  overflow-wrap: break-word;
}
.pcd__title {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 16px;
}
.pcd__body {
  font-size: 15px;
  color: #fff;
  p {
    margin-bottom: 12px;
    line-height: 1.5;
  }
}
.pcd__plan-name {
  color: #2fb54e;
  font-weight: 600;
}
.pcd__divider {
  border-top: 1px solid #434343;
  margin: 16px 0;
}
.pcd__items {
  list-style: none;
  padding: 0;
  margin: 0 0 16px;
  font-size: 15px;
  color: #fff;
  li {
    margin-bottom: 8px;
  }
}
.pcd__hint {
  font-size: 13px;
  color: #999;
  margin-bottom: 20px;
}
.pcd__actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
.pcd__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  line-height: 1.2;
  white-space: nowrap;
  box-sizing: border-box;
  cursor: pointer;
  border: none;
  &--cancel {
    background: #666;
    color: #dbdbdb;
    min-width: 80px;
  }
  &--confirm {
    background: #33ab4f;
    color: #fff;
    min-width: 142px;
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
  &--schedule {
    background: #666;
    color: #dbdbdb;
    min-width: 150px;
    height: 32px;
    border-radius: 4px;
    opacity: 0.5;
    cursor: not-allowed;
  }
  &--start-now {
    background: #33ab4f;
    color: #fff;
    min-width: 132px;
    height: 32px;
    border-radius: 4px;
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}
.pcd__cards {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  @media (max-width: 680px) {
    flex-direction: column;
  }
}
.pcd__card {
  flex: 1;
  min-width: 0;
  border-radius: 6px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  &--recommended {
    border: 1px solid #2fb54e;
  }
  &--now {
    border: 1px solid #434343;
  }
}
.pcd__card-title {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.pcd__card-tag {
  font-weight: 400;
  color: #aaa;
}
.pcd__card-desc {
  font-size: 13px;
  color: #fff;
  line-height: 1.4;
  margin-top: -12px;
}
.pcd__card-items {
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 13px;
  color: #fff;
  li {
    margin-bottom: 6px;
    word-break: normal;
    overflow-wrap: break-word;
    &::before {
      content: '• ';
      color: #2fb54e;
    }
  }
}
</style>

<style>
@media (max-width: 480px) {
  .el-message-box__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-message-box {
    width: 85vw !important;
    max-width: 85vw !important;
    min-width: unset !important;
    margin-top: 0 !important;
    box-sizing: border-box !important;
  }
  .el-message-box__content {
    word-break: break-word;
  }
}
</style>
